// 'use client';
import React from 'react';

interface VidyardVideoProps {
  videoID: string;
}

const VidyardVideo: React.FC<VidyardVideoProps> = ({ videoID }) => {
  return (
    <div>
      <iframe
        width="800"
        height="450"
        className="max-w-full"
        src={`https://play.vidyard.com/${videoID}`}
        title="Vidyard video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default VidyardVideo;